export const METRICS_WINDOW_OPTIONS = [
  { value: 'all', label: 'All Time' },
  { value: 'current', label: 'This Month' },
  { value: 'last', label: 'Last Month' },
];

const SUFFIXES = {
  current: '(This Month)',
  last: '(Last Month)',
};

export const metricsWindowSuffix = (value) => SUFFIXES[value] || '';

const SUMMARY_KEYS = { current: 'thisMonth', last: 'pastMonth' };

const METRIC_FIELDS = [
  'impressions',
  'transactions',
  'revenue',
  'totalImpressions',
  'signUps',
  'sessions',
  'signUpsAttrImpressions',
  'sessionsAttrImpressions',
];

export const applyMetricsWindow = (data, value) => {
  const summaryKey = SUMMARY_KEYS[value];
  if (!summaryKey || !data) return data;

  return data.map((advertiser) => {
    const summary = (advertiser.customSummary && advertiser.customSummary[summaryKey]) || {};
    const metrics = {};
    METRIC_FIELDS.forEach((field) => {
      metrics[field] = summary[field] || 0;
    });
    return {
      id: advertiser.id,
      name: advertiser.name,
      startDate: advertiser.startDate,
      endDate: advertiser.endDate,
      status: advertiser.status,
      ...metrics,
    };
  });
};
